<template>
  <div class="xtzbzhubo-wrapper">
    <!-- WebRTC 主播推流预览：渲染摄像头画面 -->
    <div v-if="!isHostObsLive && userInfo.cameraStatus !== 0" :id="videoContainerId" class="xtzbzhubo-video" style="object-fit: cover;"></div>
    <!-- OBS 主播小窗：用 TCPlayer 拉 OBS 推流地址显示 -->
    <video
      v-else-if="isHostObsLive && hostPullUrl"
      :id="obsPlayerId"
      class="xtzbzhubo-video obs-video"
      preload="auto"
      playsinline
      webkit-playsinline
      style="object-fit: cover;"
    ></video>
    <!-- 摄像头关闭或无拉流地址时的占位图 -->
    <div v-else class="xtzbzhubo-bg">
      <img class="xtzbzhubo-bg-img" :src="userInfo.userInfo && userInfo.userInfo.headPortrait" alt="" />
    </div>
	<div class="xtzb-item-user">
	  <span class="xtzb-item-user-sort">1</span>
	  <span class="xtzb-item-user-name">主播</span>
	</div>
  </div>
</template>

<script>
import { getChatRoomDetails, sendRefreshMsg } from "@/api/zhibo";
import { updateHelpLiveUser } from "@/api/zhubo";
export default {
  name: "xietongzhubo",
  props: {
    mainScreenData: {
      type: Object,
      default: null
    },
    liveId: {
      type: String,
      default: null
    },
    // 直播类型：1=WebRTC 手机直播，2=OBS 直播
    liveType: {
      type: [Number, String],
      default: 1
    },
    // OBS 模式下主播自己的拉流地址（chatRoomDetails.pullUrl）
    hostPullUrl: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      data: "",
      userInfo: { userInfo: {} },
      // WebRTC 推流相关
      livePusher: null,
      audioEffectManager: null,
      videoEffectManager: null,
      cameraStreamId: null,
      videoContainerId: null,
      isDeviceReady: false,
      isPushing: false,
      isMirrored: false,
      // OBS 拉流相关
      obsPlayerId: null,
      obsPlayer: null,
      obsLicenseUrl: "https://1383640469.sdk-license.com/license/v2/1383640469_1/v_cube.license"
    };
  },
  computed: {
    // 是否 OBS 直播（主播外部推流，前端只拉流显示，不操作摄像头/麦克风）
    isHostObsLive() {
      return String(this.liveType) === "2";
    }
  },
  watch: {
    mainScreenData: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.userInfo = newVal;
          if (this.isHostObsLive) {
            // OBS 模式：初始化拉流播放器
            this.$nextTick(() => this.initObsPlayer());
          } else if (!this.isDeviceReady && newVal.cameraStatus !== 0) {
            // WebRTC 模式：初始化推流
            this.getLivePusher();
          }
        }
      }
    },
    hostPullUrl: {
      handler(newUrl) {
        if (this.isHostObsLive && newUrl) {
          this.$nextTick(() => this.initObsPlayer());
        }
      }
    }
  },
  mounted() {
    this.videoContainerId = "xtzbzhubo-container-" + Date.now();
    this.obsPlayerId = "xtzbzhubo-obs-" + Date.now();
    if (this.mainScreenData) {
      this.userInfo = this.mainScreenData;
      if (this.isHostObsLive) {
        this.$nextTick(() => this.initObsPlayer());
      } else if (this.mainScreenData.cameraStatus !== 0) {
        this.$nextTick(() => {
          this.getLivePusher();
        });
      }
    }
  },
  beforeDestroy() {
    // 清理 WebRTC 推流
    if (this.livePusher) {
      this.livePusher.stopCamera();
      this.livePusher.stopMicrophone();
      this.livePusher.stopPush();
      this.livePusher.destroy();
      this.livePusher = null;
    }
    // 清理 OBS 拉流播放器
    if (this.obsPlayer) {
      try {
        this.obsPlayer.pause();
        this.obsPlayer.src("");
        this.obsPlayer.dispose();
      } catch (e) {
        console.warn("销毁 OBS 播放器失败:", e);
      }
      this.obsPlayer = null;
    }
  },
  methods: {
    // OBS 主播小窗：用 TCPlayer 拉自己的 OBS 推流地址显示，不创建 TXLivePusher、不碰摄像头
    initObsPlayer() {
      if (!this.isHostObsLive || !this.hostPullUrl) return;

      const videoEl = document.getElementById(this.obsPlayerId);
      if (!videoEl) {
        // DOM 还没渲染好，延迟重试
        setTimeout(() => this.initObsPlayer(), 100);
        return;
      }

      // 已经初始化过且地址没变：保持播放不动
      if (this.obsPlayer) {
        try {
          const currentSrc = typeof this.obsPlayer.currentSrc === "function" ? this.obsPlayer.currentSrc() : "";
          if (currentSrc === this.hostPullUrl) return;
          this.obsPlayer.src(this.hostPullUrl);
          this.obsPlayer.play();
          return;
        } catch (e) {
          console.warn("OBS 播放器恢复失败，重新初始化:", e);
          this._destroyObsPlayer();
        }
      }

      try {
        this.obsPlayer = TCPlayer(this.obsPlayerId, {
          sources: [{ src: this.hostPullUrl }],
          licenseUrl: this.obsLicenseUrl,
          autoplay: true,
          controls: false,
          muted: true, // 小窗静音，避免声音循环
          webrtcConfig: { connectRetryCount: 999999 },
          errorDisplay: false
        });
        console.log("OBS 主播小窗播放器初始化成功，地址:", this.hostPullUrl);
      } catch (error) {
        console.error("OBS 主播小窗播放器初始化失败:", error);
      }
    },
    _destroyObsPlayer() {
      if (this.obsPlayer) {
        try {
          this.obsPlayer.pause();
          this.obsPlayer.src("");
          this.obsPlayer.dispose();
        } catch (e) {}
        this.obsPlayer = null;
      }
    },

    // ======= 以下为 WebRTC 推流相关（仅 WebRTC 模式下调用） =======
    async getLivePusher(data) {
      const quality = data ? data : "720p";
      this.livePusher = new TXLivePusher();
      this.audioEffectManager = this.livePusher.getAudioEffectManager();
      this.videoEffectManager = this.livePusher.getVideoEffectManager();
      // 开启本地混流功能（镜像等视频效果依赖此功能）
      this.videoEffectManager.enableMixing(true);
      this.livePusher.setVideoQuality(quality);
      this.livePusher.setAudioQuality("standard");
      this.livePusher.setProperty("setVideoFPS", 25);
      this.livePusher.setRenderView(this.videoContainerId);
      if (this.livePusher.videoView) {
        this.livePusher.videoView.muted = true;
      }

      this.livePusher.setObserver({
        onPushStatusUpdate: (code, message) => {
          console.log("推流状态更新:", code, message);
          if (code === 1001) {
            this.isPushing = false;
          } else if (code === 1002) {
            this.isPushing = true;
            console.log("推流真正成功了");
          } else if (code === -1307) {
            this.isPushing = false;
            console.error("推流连接断开");
          }
          if (code == 2) {
            this.sendRefreshMsg();
          }
        },
        onPushError: (code, message) => {
          console.error("推流错误:", code, message);
          this.isPushing = false;
        }
      });

      try {
        this.cameraStreamId = await this.livePusher.startCamera();
        await this.livePusher.startMicrophone();
        this.isDeviceReady = true;
        await this.getChatRoomDetails();
      } catch (error) {
        console.error("媒体设备启动失败:", error);
        this.isDeviceReady = false;
      }
    },
    async sendRefreshMsg() {
      const res = await sendRefreshMsg({ liveId: this.liveId });
    },
    async startPush() {
      if (!this.isDeviceReady) {
        console.warn("设备未就绪，推流取消");
        return;
      }
      const pushUrl = this.data.chatRoomDetails ? this.data.chatRoomDetails.pushUrl : "";
      if (!pushUrl) {
        console.warn("推流地址为空");
        return;
      }
      const newUrl = pushUrl.replace(/^rtmp:\/\//, "webrtc://");
      try {
        await this.livePusher.startPush(newUrl);
      } catch (error) {
        if (error.message && error.message.includes("stream is pushing")) {
          console.warn("推流已在进行中");
        } else {
          console.error("推流发起失败:", error);
          this.isPushing = false;
        }
      }
    },
    async getChatRoomDetails() {
      if (!this.$route.query.liveId) {
        return;
      }
      const res = await getChatRoomDetails({ liveId: this.$route.query.liveId });
      this.data = res.data;
      this.startPush();
    },
    async toggleMicrophone() {
      if (!this.userInfo || !this.userInfo.helpId) return;
      const newStatus = this.userInfo.isPermitMicrophone === 1 ? 0 : 1;
      try {
        const res = await updateHelpLiveUser({
          helpId: this.userInfo.helpId,
          isPermitMicrophone: newStatus
        });
        this.$message.success(res.msg);
        this.userInfo.isPermitMicrophone = newStatus;
        if (this.livePusher) {
          if (newStatus === 1) {
            await this.livePusher.startMicrophone();
          } else {
            this.livePusher.stopMicrophone();
          }
        }
      } catch (error) {
        console.error("切换麦克风失败:", error);
      }
    },
    // 切换摄像头（禁用/启用视频流）
    toggleCamera(enable) {
      // OBS 模式：摄像头由 OBS 外部控制，前端不操作
      if (this.isHostObsLive) return;
      if (!this.livePusher) return;
      try {
        this.livePusher.setVideoMute(!enable);
      } catch (error) {
        console.error("切换摄像头失败:", error);
      }
    },
    // 切换麦克风（禁用/启用音频流）
    toggleMic(enable) {
      // OBS 模式：麦克风由 OBS 外部控制，前端不操作
      if (this.isHostObsLive) return;
      if (!this.livePusher) return;
      try {
        this.livePusher.setAudioMute(!enable);
      } catch (error) {
        console.error("切换麦克风失败:", error);
      }
    },
    // 切换镜像
    toggleMirror(enable) {
      // OBS 模式：无本地推流预览镜像概念
      if (this.isHostObsLive) return;
      if (!this.videoEffectManager || !this.cameraStreamId) {
        console.error("视频效果管理器或流ID不可用");
        return;
      }
      try {
        this.videoEffectManager.setMirror({
          streamId: this.cameraStreamId,
          mirrorType: enable ? 1 : 0
        });
        this.isMirrored = enable;
      } catch (error) {
        console.error("切换镜像失败:", error);
      }
    },
    // 设置音量（同时控制混音音量和推流音频轨道静音）
    setVolume(val) {
      // OBS 模式：音频由 OBS 外部控制，前端不操作
      if (this.isHostObsLive) return;
      if (this.audioEffectManager) {
        this.audioEffectManager.setVolume(val);
      }
      if (this.livePusher) {
        this.livePusher.setAudioMute(val == 0);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.xtzbzhubo-wrapper {
  width: 100px;
  height: 100px;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  background-color: #000;
  margin-right: 10px;
}

.xtzbzhubo-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 98;
}
.obs-video {
  background: #000;
}

.xtzbzhubo-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
}

.xtzbzhubo-bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.xtzb-item-user {
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  z-index: 100;
}
.xtzb-item-user-sort {
  width: 14px;
  height: 14px;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 16px 16px 16px 16px;
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 9px;
  color: #ffffff;
  line-height: 14px;
  text-align: center;
}
.xtzb-item-user-name {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
  margin-left: 4px;
}
</style>
<style>
.xtzbzhubo-video video {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
}

.xtzbzhubo-video video::-webkit-media-controls {
  display: none !important;
}

.xtzbzhubo-video video::-webkit-media-controls-enclosure {
  display: none !important;
}

.xtzbzhubo-video video::-webkit-media-controls-panel {
  display: none !important;
}

.xtzbzhubo-wrapper button,
.xtzbzhubo-wrapper .vjs-big-play-button,
.xtzbzhubo-wrapper .tcp-big-play-button,
.xtzbzhubo-wrapper .vjs-control-bar {
  display: none !important;
  pointer-events: none !important;
}

/* 隐藏 TCPlayer 加载转圈和错误弹窗 */
.xtzbzhubo-wrapper .tcp-loading-spinner {
  display: none !important;
}
.xtzbzhubo-wrapper .tcp-error-display {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// xietongzhubo.vue?e53cb316